import { forwardRef, type Ref, type SVGProps } from "react";
const IconTextItalicsOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M24 4V2H12v2h4.74L11.2 28H6v2h12v-2h-4.74L18.8 4z" />
  </svg>
);
const ForwardRef = forwardRef(IconTextItalicsOutlineSVG);
ForwardRef.displayName = "IconTextItalicsOutline";
export { ForwardRef as IconTextItalicsOutline };
